import { forwardRef } from 'react';
import styled from 'styled-components';
import type { ToTransientProps } from 'types/styled';
import type { ImageProps } from './shared/types';

const AspectRatioContainer = styled.div`
    display: flex;
    max-width: 100%;
    max-height: 100%;
`;

type TransientImageProps = ToTransientProps<ImageProps>;
type ImageWithRatioProps = Pick<TransientImageProps, '$aspectRatio' | '$objectFit'>;

const ImageWithRatio = styled.img<ImageWithRatioProps>`
    object-fit: ${({ $objectFit }) => $objectFit};
    aspect-ratio: ${({ $aspectRatio }) => $aspectRatio};
    overflow: hidden;
    width: 100%;
    height: 100%;
`;

const Image = forwardRef<HTMLImageElement, ImageProps>(
    (
        { alt, aspectRatio, objectFit = 'cover', AspectRatioContainerRenderer = AspectRatioContainer, ...restProps },
        ref
    ) => {
        if (aspectRatio) {
            return (
                <AspectRatioContainerRenderer>
                    <ImageWithRatio
                        alt={alt}
                        ref={ref}
                        $aspectRatio={aspectRatio}
                        $objectFit={objectFit}
                        {...restProps}
                    />
                </AspectRatioContainerRenderer>
            );
        }
        return <img alt={alt} ref={ref} {...restProps} />;
    }
);

export { AspectRatioContainer };
export default Image;
